import { Component, HostListener } from '@angular/core';
import { Endpoint, LocalStorageKey } from './models/enums';
import { CommonService } from './services/common/common.service';
import { RestService } from './services/rest/rest.service';

@Component({
    standalone: false,
    selector: 'res-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent {

    constructor(private commonService: CommonService, private restService: RestService) { }

    title = 'Review Enhancements';
    @HostListener('window:beforeunload', ['$event'])
    beforeUnloadHandler($event: any) {
        const isForcedReload = localStorage.getItem(LocalStorageKey.AppForcedReload);
        const isTpAuthRedirect = localStorage.getItem(LocalStorageKey.IsTpAuthRedirect);
        // Alert the user window is closing
        if ($event.target && ($event.target.title === 'eDiscovery Doc Viewer' || $event.target.title === 'Promotion Tracking' ||
            $event.target.title === 'eDiscovery Work Basket' || isForcedReload || isTpAuthRedirect || $event.target.title === 'eDiscovery Status')) {
            return;
        } else {
            if (this.commonService.projectName) {
                this.restService.post(Endpoint.projectManager_closeProject, { handle: this.commonService.projectName });
            }
            return false;
        }
    }
}
